import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminProductQuantityHistoryReasonType } from '../../enums/admin-product-quantity-history-reason-type';
import { AdminProductQuantityHistoryReasonTypePipe } from '../../pipes/admin-product-quantity-history-reason-type.pipe';

@Component({
  selector: 'app-admin-product-quantity-history-reason-type',
  imports: [CommonModule, AdminProductQuantityHistoryReasonTypePipe],
  templateUrl: './admin-product-quantity-history-reason-type.component.html',
  styleUrl: './admin-product-quantity-history-reason-type.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminProductQuantityHistoryReasonTypeComponent {
  public readonly type = input.required<AdminProductQuantityHistoryReasonType>();

  protected readonly cssClass = computed(() => {
    switch (this.type()) {
      case AdminProductQuantityHistoryReasonType.NewProduct:
        return 'text-green-600';

      case AdminProductQuantityHistoryReasonType.ByNewOrder:
        return 'text-blue-600';

      case AdminProductQuantityHistoryReasonType.ByAddToOrderShipment:
        return 'text-zinc-600';

      case AdminProductQuantityHistoryReasonType.ByRemoveFromOrderShipment:
        return 'text-mauve-600';

      case AdminProductQuantityHistoryReasonType.ByCancelOrder:
        return 'text-indigo-600';

      case AdminProductQuantityHistoryReasonType.ByRefundOrder:
        return 'text-emerald-700';

      case AdminProductQuantityHistoryReasonType.Manual:
        return 'text-fuchsia-600';

      default:
        return '';
    }
  });
}
